import { switchPieveUserCompany } from '@/redux/requests/companiesRequests.js';
import loadSignedInContext from './loadSignedInContext.js';

/**
 * Moves the session to another of the person's organizations: the server saves the choice, the
 * previous organization's data is cleared, and the signed-in context loads again for the new one.
 */
const switchOrganization = ({ companyId }) => {
  return async (dispatch) => {
    const switchRes = await switchPieveUserCompany({ companyId });

    if (switchRes?.success === false) {
      return switchRes;
    }

    dispatch({ type: 'RESET_PIEVE_ACTIVE_COMPANY_SCOPE' });
    return dispatch(loadSignedInContext({ companyId }));
  };
};

export default switchOrganization;
